import { parsePhoneNumber, AsYouType } from 'libphonenumber-js'

/**
 * Formats a phone number to a consistent US format: (XXX) XXX-XXXX
 * Handles various input formats like +14025808297, 402-502-7492, etc.
 *
 * @param phone - The phone number string to format
 * @returns Formatted phone number string or original if formatting fails
 */
export function formatPhoneNumber(phone: string | null | undefined): string {
  if (!phone || !phone.trim()) {
    return ''
  }

  // Remove any whitespace
  const cleaned = phone.trim()

  try {
    // Try to parse as a phone number with US as default country
    const phoneNumber = parsePhoneNumber(cleaned, 'US')

    if (phoneNumber && phoneNumber.isValid()) {
      // Format as US national format: (402) 904-4899
      return phoneNumber.formatNational()
    }
  } catch (parseError) {
    // If parsePhoneNumber fails, try using AsYouType formatter for partial/invalid numbers
    try {
      const formatter = new AsYouType('US')
      const formatted = formatter.input(cleaned)

      // If we got a formatted result that's different from input, return it
      if (formatted && formatted.length > 0 && formatted !== cleaned) {
        return formatted
      }
    } catch (formatError) {
      // If both methods fail, silently return original
      // Don't log warnings for every invalid number as it's expected
    }
  }

  // Fallback: return original if we can't format it
  return cleaned
}
